// extracted by mini-css-extract-plugin
export default {"delete-watchlist-container":"nlMow0y3yL6JbSAjKRL1","delete-watchlist-header":"MQ65E5wlofLgm3mhbYvv","delete-watchlist-footer":"HoSbaGr9Ep2SPDmFqVP_"};